"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var CustomRenderer = _interopRequireWildcard(require("UIComponents/utils/propTypes/customRenderer"));

var _Review = _interopRequireDefault(require("../../../records/Review"));

var _dummyReviews = require("../../../constants/reviews/dummyReviews");

var _renderers = _interopRequireDefault(require("../renderers"));

var BaseReviewModal = function BaseReviewModal(_ref) {
  var review = _ref.review,
      ReviewRenderer = _ref.ReviewRenderer,
      title = _ref.title,
      form = _ref.form,
      onConfirm = _ref.onConfirm,
      onClose = _ref.onClose,
      confirmButtonText = _ref.confirmButtonText,
      cancelButtonText = _ref.cancelButtonText,
      confirmDisabled = _ref.confirmDisabled,
      tooltip = _ref.tooltip,
      width = _ref.width;
  return _react.default.createElement(_UIModal.default, {
    width: width
  }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_H.default, null, title), _react.default.createElement(_UIDialogCloseButton.default, {
    onClick: onClose
  })), _react.default.createElement(_UIDialogBody.default, null, form, _react.default.createElement(ReviewRenderer, {
    review: review
  })), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UITooltip.default, {
    disabled: !confirmDisabled || !tooltip,
    title: tooltip
  }, _react.default.createElement(_UIButton.default, {
    use: "primary",
    disabled: confirmDisabled,
    onClick: onConfirm
  }, confirmButtonText)), _react.default.createElement(_UIButton.default, {
    use: "secondary",
    onClick: onClose
  }, cancelButtonText)));
};

BaseReviewModal.propTypes = {
  review: _propTypes.default.instanceOf(_Review.default),
  ReviewRenderer: CustomRenderer.propType,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  form: CustomRenderer.propType,
  onConfirm: _propTypes.default.func.isRequired,
  onClose: _propTypes.default.func.isRequired,
  confirmButtonText: _propTypes.default.node,
  cancelButtonText: _propTypes.default.node,
  confirmDisabled: _propTypes.default.bool,
  tooltip: _propTypes.default.node,
  width: _propTypes.default.number
};
BaseReviewModal.defaultProps = {
  review: _dummyReviews.review2,
  ReviewRenderer: _renderers.default,
  confirmButtonText: _react.default.createElement(_FormattedMessage.default, {
    message: "ecosystemMarketplaceCore.reviews.modal.confirm"
  }),
  cancelButtonText: _react.default.createElement(_FormattedMessage.default, {
    message: "ecosystemMarketplaceCore.reviews.modal.cancel"
  }),
  confirmDisabled: false,
  width: 800
};
var _default = BaseReviewModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/modals/BaseReviewModal.js
// module id = 873
// module chunks = 209 210 211 212